import LessonUpdatePage from "./LessonUpdatePage";

export default LessonUpdatePage;